import { render, staticRenderFns } from "./ShowEtapaPage.vue?vue&type=template&id=1ca54ec0&scoped=true"
import script from "./ShowEtapaPage.vue?vue&type=script&lang=js"
export * from "./ShowEtapaPage.vue?vue&type=script&lang=js"
import style0 from "./ShowEtapaPage.vue?vue&type=style&index=0&id=1ca54ec0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ca54ec0",
  null
  
)

export default component.exports